import { apiService } from "../services/api.service";

export const vlnyController = {
    getZoznamVln,
    getZoznamVlnaArtikle
};

function getZoznamVln() {
    return apiService.fetchApiRequest("api/Vlny/GetZoznamVln");
}
function getZoznamVlnaArtikle(idVlny) {
    return apiService.fetchApiRequest("api/Vlny/GetZoznamVlnaArtikle?idVlny=" + idVlny);
}



// WEBPACK FOOTER //
// ./src/controllers/vlny.controller.js